import { render, staticRenderFns } from "./OneVillageOneProductExplore.vue?vue&type=template&id=58e58567&scoped=true&"
import script from "./OneVillageOneProductExplore.vue?vue&type=script&lang=js&"
export * from "./OneVillageOneProductExplore.vue?vue&type=script&lang=js&"
import style0 from "./OneVillageOneProductExplore.vue?vue&type=style&index=0&id=58e58567&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e58567",
  null
  
)

export default component.exports